export default __webpack_public_path__ + "static/media/log.cd4bacb6.png";